import React from 'react';
let _shareURL = '';
let _IframeURL = 'http://127.0.0.1:1235/iframe.html';
import Dropdown from 'react-dropdown';
// import { toast } from 'react-toastify';
import toast from '../../components/Toastify';
// import DatePicker from 'react-datepicker';
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';

// start quill
import ReactQuill, { Quill } from 'react-quill';

var custTagDropDown = Quill.import('ui/picker');
custTagDropDown = [];
Quill.register(custTagDropDown, true);

const customHandlerDrpDown = {
  'custTagDropDown': function (value) {
    if (this.quill.getText().includes(value) != true)
      this.quill.insertText(this.quill.getSelection().index, '{{' + value + '}}', 'user');
    else
      toast.error('{{' + value + '}} alreary available');
  }
};

const toolbarModule = {
  container: [
    [{ 'custTagDropDown': [] }],
    [{ 'list': 'ordered' }, { 'list': 'bullet' }]
  ],
  handlers: customHandlerDrpDown
};

//for common module
const modulesQuill = {
  toolbar: toolbarModule
};

//for format quill
const formatsQuill = [
  'header', 'font', 'size',
  'bold', 'italic', 'underline', 'strike', 'blockquote',
  'list', 'bullet', 'indent', 'align',
  'link', 'image', 'background', 'color', 'emoji'
];
// end quill

const durationOptn = [
  { value: 'days', label: 'Days' },
  { value: 'hours', label: 'Hours' },
  { value: 'minutes', label: 'Minutes' },
];

const automationOptn = [
  { value: '0', label: 'Specific date' },
  { value: '1', label: 'Interval' },
  { value: '2', label: 'Every date of month' },
  { value: '3', label: 'Every day of week' },
];

const daysOptions = [
  { value: '1', label: '1 day' },
  { value: '2', label: '2 days' },
  { value: '3', label: '3 days' },
  { value: '4', label: '4 days' },
  { value: '5', label: '5 days' },
  { value: '6', label: '6 days' },
  { value: '7', label: '7 days' },
  { value: '8', label: '8 days' },
  { value: '9', label: '9 days' },
  { value: '10', label: '10 days' },
  { value: '11', label: '11 days' },
  { value: '12', label: '12 days' },
  { value: '13', label: '13 days' },
  { value: '14', label: '14 days' },
  { value: '15', label: '15 days' },
  { value: '16', label: '16 days' },
  { value: '17', label: '17 days' },
  { value: '18', label: '18 days' },
  { value: '19', label: '19 days' },
  { value: '20', label: '20 days' },
  { value: '21', label: '21 days' },
  { value: '22', label: '22 days' },
  { value: '23', label: '23 days' },
  { value: '24', label: '24 days' },
  { value: '25', label: '25 days' },
  { value: '26', label: '26 days' },
  { value: '27', label: '27 days' },
  { value: '28', label: '28 days' },
  { value: '29', label: '29 days' },
  { value: '30', label: '30 days' },
  { value: '31', label: '31 days' }
];

const weekDays = [
  { value: 'sun', label: 'Sunday' },
  { value: 'mon', label: 'Monday' },
  { value: 'tue', label: 'Tuesday' },
  { value: 'wed', label: 'Wednesday ' },
  { value: 'thu', label: 'Thursday ' },
  { value: 'fri', label: 'Friday' },
  { value: 'sat', label: 'Saturday' },
];

let _arrRepeatDt = [];
let _arrRepeatWkday = [];
const AutomationCard = ({
  cnf,
  handleCnfChange,
  isPlnPurchase,
  openGetCodeModel,
  widgetById,
  copyWidgetDiv,
  handleCancelSchedule
}) => {
  _shareURL = _IframeURL + '?id=widget_' + widgetById._id + '&wm=' + widgetById.wid + '&unqid=' + widgetById.unqid + '&ti=' + widgetById.ti + '';

  //create dynemic value dropdown for editor
  let arrChips = ['USERNAME', 'PRODUCT_NAME', 'LINK'];
  toolbarModule.container[0][0].custTagDropDown = arrChips;
  var style = document.createElement('style');
  document.head.appendChild(style);
  for (let i = 0; i < arrChips.length; i++) {
    const e = arrChips[i];
    style.sheet.insertRule('.ql-picker-options span[data-value=' + e + ']::before {content: "{{' + e + '}}" !important;}');
    style.sheet.insertRule('.ql-picker-label[data-value=' + e + ']::before {content: "Dynamic Value" !important;}');
  }
  //end create dynemic value dropdown for editor
  if (cnf && cnf.atmntgrevrydt) {
    _arrRepeatDt = [];
    daysOptions.filter(x => {
      cnf.atmntgrevrydt.filter(y => {
        if (x.value == y) {
          _arrRepeatDt.push(x);
        }
      });
    });
  }

  if (cnf && cnf.atmntgrevrywk) {
    _arrRepeatWkday = [];
    weekDays.filter(x => {
      cnf.atmntgrevrywk.filter(y => {
        if (x.value == y) {
          _arrRepeatWkday.push(x);
        }
      });
    });
  }

  return (
    <div className="tabs-layout-content">
      <div className="card card-editor card-template">
        {
          !isPlnPurchase ?
            <div>
              <input type='button' value='Purchase plan' onClick={() => openGetCodeModel(widgetById)} />
            </div>
            :
            <div>
              {widgetById._id &&
                <div className="card-editor-block p-0">
                  <label className="card-editor-title">Script</label>
                  <div className="customize-list">
                    <div className="">
                      <div className="inst-code-design">
                        <h5>Copy and paste this code.</h5>
                        <div className="inst-types-manually">
                          <div className="wdgt-code-script">
                            <pre>{_shareURL}</pre>
                          </div>
                          <div className="copy-script-upbg" id='copy-shareURL-blk' onClick={() => copyWidgetDiv(_shareURL, 'copy-shareURL-blk')}>
                            <div className="copy-script-content">
                              <div className="copy-text">Copy and paste this code into desired place of your website</div>
                              <a href="#" className="nf-btn nf-btn-default">
                                <span className="btn-copytext-dflt">Get code</span>
                                <span className="btn-copytext-hover">Copy code</span>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }
              <div className="card-editor-block p-0 mt-35">
                <label className="card-editor-title">Trigger</label>
                <div className="customize-list">
                  <div className="dd-ctalabel mt-4">
                    <label className="label-title">Cancel schedule</label>
                    <div className="text-center add-new-whatsapp-num mt-3">
                      <button type='button' className="nf-btn nf-btn-default" onClick={handleCancelSchedule}>
                        Cancel
                      </button>
                    </div>
                  </div>

                  {/* [S] automation type */}
                  <div className="dd-ctalabel mt-4">
                    <label className="label-title">Select automation type</label>
                    <Dropdown className="nf-select-dropdown nf-select-defaultdd" value={cnf.atmntgrtyp} options={automationOptn} onChange={(e) => handleCnfChange('atmntgrtyp', e.value)} />
                  </div>
                  {cnf.atmntgrtyp == '0' ?
                    <div>
                      {/* <DatePicker
                        selected={cnf.atmntgrspfcdt ? new Date(cnf.atmntgrspfcdt) : null}
                        onChange={date => handleCnfChange('atmntgrspfcdt', date)}
                        className={'editor-input-content editor-input-fullwidth '}
                        showTimeSelect
                        dateFormat="dd/MMM/yyyy h:mm aa" /> */}
                    </div>
                    :
                    cnf.atmntgrtyp == '1' ?
                      <div>
                        {cnf.atmntgrdrtn != undefined &&
                          <div className="dd-ctalabel mt-4">
                            <label className="label-title">Select Days/hours</label>
                            <Dropdown className="nf-select-dropdown nf-select-defaultdd" value={cnf.atmntgrdrtn} options={durationOptn} onChange={(e) => handleCnfChange('atmntgrdrtn', e.value)} />
                          </div>
                        }
                        {cnf.atmntgrunt != undefined &&
                          <div className="editor-input header-editor-ckeditor editor-header-title">
                            <label className="label-title">Select duration</label>
                            <input type="number" name="wbstlnk" className="editor-input-content editor-input-fullwidth" value={cnf.atmntgrunt} onChange={(e) => handleCnfChange('atmntgrunt', e.target.value)} placeholder={cnf.atmntgrdrtn == 'days' ? 'Enter days' : 'Enter hours'} />
                          </div>
                        }
                      </div>
                      :
                      cnf.atmntgrtyp == '2' ?
                        <div>
                          <ReactMultiSelectCheckboxes className="dropdown-item"
                            value={_arrRepeatDt}
                            options={daysOptions}
                            onChange={(e) => handleCnfChange('atmntgrevrydt', e)}
                            placeholderButtonLabel='Select date' />

                          {/* <DatePicker
                            selected={cnf.atmntgrevrymthtm ? new Date(cnf.atmntgrevrymthtm) : null}
                            onChange={date => handleCnfChange('atmntgrevrymthtm', date)}
                            className={'editor-input-content editor-input-fullwidth '}
                            showTimeSelect
                            showTimeSelectOnly
                            timeIntervals={5}
                            dateFormat="h:mm aa" /> */}
                        </div>
                        :
                        cnf.atmntgrtyp == '3' ?
                          <div>
                            <ReactMultiSelectCheckboxes className="dropdown-item"
                              value={_arrRepeatWkday}
                              options={weekDays}
                              onChange={(e) => handleCnfChange('atmntgrevrywk', e)}
                              placeholderButtonLabel='Select date' />

                            {/* <DatePicker
                              selected={cnf.atmntgrevrywktm ? new Date(cnf.atmntgrevrywktm) : null}
                              onChange={date => handleCnfChange('atmntgrevrywktm', date)}
                              className={'editor-input-content editor-input-fullwidth '}
                              showTimeSelect
                              showTimeSelectOnly
                              timeIntervals={5}
                              dateFormat="h:mm aa" /> */}
                          </div>
                          :
                          ''
                  }



                  {/* [E] automation type */}
                  {cnf.atmntgremlfrmadd != undefined &&
                    <div className="editor-input header-editor-ckeditor editor-header-title">
                      <label className="label-title">From email</label>
                      <input type="text" className="editor-input-content editor-input-fullwidth"
                        value={cnf.atmntgremlfrmadd}
                        onChange={(e) => handleCnfChange('atmntgremlfrmadd', e.target.value)} />
                    </div>
                  }
                  {cnf.atmntgremlsub != undefined &&
                    <div className="editor-input header-editor-ckeditor editor-header-title">
                      <label className="label-title">Email subject</label>
                      <input type="text" className="editor-input-content editor-input-fullwidth"
                        value={cnf.atmntgremlsub}
                        onChange={(e) => handleCnfChange('atmntgremlsub', e.target.value)} />
                    </div>
                  }
                  {cnf.atmntgremltmplt != undefined &&
                    <div className="editor-input header-editor-ckeditor editor-header-title">
                      <label className="label-title">Email template</label>
                      <ReactQuill value={cnf.atmntgremltmplt} modules={modulesQuill} formats={formatsQuill}
                        onChange={(newValue, delta, source) => {
                          if (source === 'user') {
                            handleCnfChange('atmntgremltmplt', newValue);
                          }
                        }} />
                    </div>
                  }
                </div>
              </div>
            </div>
        }
      </div>
    </div>
  );
};

export default AutomationCard;


// WEBPACK FOOTER //
// ./src/components/Widget/AutomationCard.js